import React from 'react';

// Ported from the Had. Collective design system (component: brand/MediumshipLogo).
// "Had." set in Abril Fatface with the period as a filled circle, "mediumship"
// in Arvo beneath or beside it. Proportions all derive from `size` so the
// dot, gap, and subline can't drift out of sync.
const TONES = {
  primary: { word: 'var(--had-ink)', dot: 'var(--had-pink)', sub: 'var(--had-pink)', rule: 'var(--had-pink)' },
  reversed: { word: '#ffffff', dot: '#ffffff', sub: '#ffffff', rule: '#ffffff' },
  mono: { word: 'var(--had-ink)', dot: 'var(--had-ink)', sub: 'var(--had-ink)', rule: 'var(--had-ink)' }
};

export default function MediumshipLogo({ variant = 'stacked', tone = 'primary', size = 64, style, ...rest }) {
  const c = TONES[tone] || TONES.primary;
  const word = {
    fontFamily: "'Abril Fatface', Georgia, serif",
    fontWeight: 400,
    fontSize: size,
    lineHeight: 0.86,
    color: c.word
  };
  const dot = {
    width: Math.round(size * 0.283),
    height: Math.round(size * 0.283),
    borderRadius: '50%',
    background: c.dot,
    marginBottom: Math.round(size * 0.043),
    flex: '0 0 auto'
  };
  const sub = {
    fontFamily: "'Arvo', Georgia, serif",
    fontSize: Math.round(size * 0.239),
    lineHeight: 1.1,
    color: c.sub
  };

  const lockup = (
    <span style={{ display: 'flex', alignItems: 'flex-end', gap: Math.round(size * 0.098) }}>
      <span style={word}>Had</span>
      <span style={dot} />
    </span>
  );

  if (variant === 'mark') {
    return <span role="img" aria-label="Had Mediumship" style={{ display: 'inline-flex', ...style }} {...rest}>{lockup}</span>;
  }
  if (variant === 'horizontal') {
    return (
      <span role="img" aria-label="Had Mediumship" style={{ display: 'inline-flex', alignItems: 'flex-end', gap: Math.round(size * 0.28), ...style }} {...rest}>
        {lockup}
        <span style={{ width: 1, alignSelf: 'stretch', background: c.rule, opacity: 0.6, flex: '0 0 auto' }} />
        <span style={sub}>mediumship</span>
      </span>
    );
  }
  return (
    <span role="img" aria-label="Had Mediumship" style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', ...style }} {...rest}>
      {lockup}
      <span style={{ ...sub, marginTop: Math.round(size * 0.174) }}>mediumship</span>
    </span>
  );
}
